<template>
  <div class="container">
    <overlay-loading v-model="loadingAll" />

    <div class="mb-4">
      <div class="d-flex align-center title-field-wrapper">
        <v-text-field
            v-if="editar && isTituloEditing && podeEditarTituloSubtitulo"
            v-model="contatosFormatado.cabecalho.titulo"
            outlined
            dense
            hide-details
            class="full-width-input no-border-focus input-alignment-fix"
            @blur="saveAllChanges('Título', null, 'titulo')"
            @keyup.enter="saveAllChanges('Título', null, 'titulo')"
            ref="tituloInput"
            :disabled="!podeEditarTituloSubtitulo"
        />
        <h2 v-else-if="editar" @click="enableEditTitulo" class="editable-text-field title-text-field" :class="{'disabled-click': !podeEditarTituloSubtitulo}">{{ contatosFormatado.cabecalho.titulo }}</h2>
        <h2 v-else class="title-text-field title-display-margin">{{ contatosFormatado.cabecalho.titulo }}</h2>
      </div>

      <div class="d-flex align-center subtitle-field-wrapper">
        <v-text-field
            v-if="editar && isSubtituloEditing && podeEditarTituloSubtitulo"
            v-model="contatosFormatado.cabecalho.subtitulo"
            outlined
            dense
            hide-details
            class="full-width-input no-border-focus input-alignment-fix"
            @blur="saveAllChanges('Subtítulo', null, 'subtitulo')"
            @keyup.enter="saveAllChanges('Subtítulo', null, 'subtitulo')"
            ref="subtituloInput"
            :disabled="!podeEditarTituloSubtitulo"
        />
        <p v-else-if="editar" @click="enableEditSubtitulo" class="editable-text-field subtitle-text-field" :class="{'disabled-click': !podeEditarTituloSubtitulo}">{{ contatosFormatado.cabecalho.subtitulo }}</p>
        <p v-else class="subtitle-text-field subtitle-display-margin">{{ contatosFormatado.cabecalho.subtitulo }}</p>
      </div>

      <div>
        <v-label class="website-label website-label-display-margin">Website da Unimed</v-label>
        <v-text-field
            v-if="editar && isWebsiteEditing && podeEditarWebsite"
            v-model="contatosFormatado.cabecalho.webSite"
            outlined
            dense
            hide-details
            class="full-width-input no-border-focus input-alignment-fix website-input-fix"
            @blur="saveAllChanges('Website', null, 'webSite')"
            @keyup.enter="saveAllChanges('Website', null, 'webSite')"
            ref="websiteInput"
            :disabled="!podeEditarWebsite"
            :error-messages="(apiErrors.cabecalho && apiErrors.cabecalho.webSite) ? apiErrors.cabecalho.webSite : ''"
            :error="!!(apiErrors.cabecalho && apiErrors.cabecalho.webSite)"
        />
        <a v-else-if="editar && podeEditarWebsite" @click.prevent="enableEditWebsite" :href="formattedWebsite" target="_blank" class="editable-text-field website-text-field no-underline-link website-display-block website-link-display-margin" :class="{'disabled-click': !podeEditarWebsite}">
          {{ contatosFormatado.cabecalho.webSite || 'Clique para adicionar' }}
        </a>
        <a v-else :href="formattedWebsite" target="_blank" class="website-text-field no-underline-link website-display-block website-link-display-margin">
          {{ contatosFormatado.cabecalho.webSite || '-' }}
        </a>
      </div>
    </div>

    <v-simple-table dense class="full-width-table table-no-padding">
      <thead>
      <tr>
        <th class="text-left area-column-flexible">Área</th>
        <th class="text-left phone-column-flexible">Telefone</th>
        <th class="text-left whatsapp-column-flexible">WhatsApp</th>
        <th class="text-left email-column-flexible">E-mail</th>
        <th class="text-left observation-column-flexible">Obs</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(dados, areaKey) in contatosFormatado.contatos" :key="areaKey">
        <td class="text-left area-column-flexible" v-html="areaDisplayNamesFormatado[areaKey]"></td>

        <td class="table-cell-padding-fix">
          <v-text-field
              v-if="editar && isTelefoneEditing[areaKey]"
              :value="formatPhoneNumber(dados.telefone)"
              @input="updatePhoneNumber(areaKey, $event)"
              outlined
              dense
              hide-details
              class="full-width-input no-border-focus table-cell-editor-fix"
              @blur="saveAllChanges(areaDisplayNames[areaKey], areaKey, 'telefone')"
              @keyup.enter="saveAllChanges(areaDisplayNames[areaKey], areaKey, 'telefone')"
              :ref="`input-${areaKey}-telefone`"
              :error-messages="(apiErrors[areaKey] && apiErrors[areaKey].telefone) ? apiErrors[areaKey].telefone : ''" :error="!!(apiErrors[areaKey] && apiErrors[areaKey].telefone)"
              :maxlength="getPhoneMaxlength(dados.telefone)" />
          <span v-else-if="editar" @click="enableEdit('telefone', areaKey)" class="editable-text-field table-cell-display-fix">{{ formatPhoneNumber(dados.telefone) || 'Clique para adicionar' }}</span>
          <span v-else class="table-cell-display-fix">{{ formatPhoneNumber(dados.telefone) || '-' }}</span>
        </td>

        <td class="table-cell-padding-fix">
          <v-text-field
              v-if="editar && isWhatsappEditing[areaKey]"
              :value="formatWhatsappNumber(dados.whatsapp)"
              @input="updateWhatsappNumber(areaKey, $event)"
              outlined
              dense
              hide-details
              class="full-full-width-input no-border-focus table-cell-editor-fix"
              @blur="saveAllChanges(areaDisplayNames[areaKey], areaKey, 'whatsapp')"
              @keyup.enter="saveAllChanges(areaDisplayNames[areaKey], areaKey, 'whatsapp')"
              :ref="`input-${areaKey}-whatsapp`"
              :error-messages="(apiErrors[areaKey] && apiErrors[areaKey].whatsapp) ? apiErrors[areaKey].whatsapp : ''" :error="!!(apiErrors[areaKey] && apiErrors[areaKey].whatsapp)"
              :maxlength="getWhatsappMaxlength(dados.whatsapp)" /> <span v-else-if="editar" @click="enableEdit('whatsapp', areaKey)" class="editable-text-field table-cell-display-fix">{{ formatWhatsappNumber(dados.whatsapp) || 'Clique para adicionar' }}</span>
          <span v-else class="table-cell-display-fix">{{ formatWhatsappNumber(dados.whatsapp) || '-' }}</span>
        </td>

        <td class="table-cell-padding-fix email-cell-stretch">
          <v-text-field
              v-if="editar && isEmailEditing[areaKey]"
              :value="dados.email"
              outlined
              dense
              hide-details
              class="full-width-input no-border-focus email-input-fix-internal table-cell-editor-fix"
              @blur="saveAllChanges(areaDisplayNames[areaKey], areaKey, 'email')"
              @keyup.enter="saveAllChanges(areaDisplayNames[areaKey], areaKey, 'email')"
              :ref="`input-${areaKey}-email`"
              :error-messages="(apiErrors[areaKey] && apiErrors[areaKey].email) ? apiErrors[areaKey].email : ''" :error="!!(apiErrors[areaKey] && apiErrors[areaKey].email)"
              @input="updateEmailToLowerCase(areaKey, $event)" />
          <span v-else-if="editar" @click="enableEdit('email', areaKey)" class="editable-text-field table-cell-display-fix">{{ dados.email || 'Clique para adicionar' }}</span>
          <span v-else class="table-cell-display-fix">{{ dados.email || '-' }}</span>
        </td>

        <td class="observation-column-flexible table-cell-padding-fix">
          <ButtonRounded
              iconName="eye"
              :iconSize="16"
              name="visualizar-obs"
              tooltipName="Visualizar Observação"
              @click="openContatoModal(dados.observacao, false, areaKey)"
          />
          <ButtonRounded
              v-if="editar"
              iconName="edit"
              :iconSize="16"
              name="editar-obs"
              tooltipName="Editar Observação"
              :closeIcon="false"
              @click="openContatoModal(dados.observacao, true, areaKey)"
          />
        </td>
      </tr>
      </tbody>
    </v-simple-table>

    <ValidationObserver ref="observer" v-if="!loadingAll">
      <v-row class="mt-3 mb-3">
        <v-col cols="12" sm="12" class="pb-0">
          <v-label v-if="editar || contatosFormatado.cabecalho.observacao" for="observacoes-field" class="observations-label">Observações</v-label>

          <ValidationProvider rules="max:1000" v-slot:default="{ errors }" v-if="editar && isObservacoesEditing && podeEditarObservacoes">
            <v-textarea
                v-model="contatosFormatado.cabecalho.observacao"
                outlined
                dense
                hide-details
                rows="3" auto-grow class="full-width-input no-border-focus observations-textarea-fix input-alignment-fix" ref="observacoesInput"
                @blur="saveAllChanges('Observações Gerais', null, 'observacao')"
                @keyup.enter.native.prevent="saveAllChanges('Observações Gerais', null, 'observacao')"
                id="observacoes-field"
                :disabled="!podeEditarObservacoes"
                :error-messages="errors[0] || (apiErrors.cabecalho && apiErrors.cabecalho.observacao) ? (errors[0] || apiErrors.cabecalho.observacao) : ''"
                :error="!!errors[0] || !!(apiErrors.cabecalho && apiErrors.cabecalho.observacao)"
            />
          </ValidationProvider>

          <p v-else-if="editar" @click="podeEditarObservacoes && enableEditObservacoes()" class="mt-3 editable-text-field observations-display-field" :class="{'disabled-click': !podeEditarObservacoes}">
            {{ contatosFormatado.cabecalho.observacao || (podeEditarObservacoes ? 'Clique para adicionar observações' : 'Campo disponível para edição apenas para o perfil Dirigente') }}
          </p>
          <p v-else class="mt-3 observations-display-field">
            {{ contatosFormatado.cabecalho.observacao || 'Nenhuma observação cadastrada' }}
          </p>
        </v-col>
      </v-row>
    </ValidationObserver>

    <ContatoModal
        :showModal="showContatoModal"
        :observation="currentObsModal"
        :editable="isContatoModalEditing"
        @close="closeContatoModal"
        @save="saveObsFromContatoModal"
    />

    <v-snackbar
        v-model="snackbarLocal.show"
        :color="snackbarLocal.color"
        :timeout="snackbarLocal.timeout"
        bottom
        right
        class="mb-8"
    >
      {{ snackbarLocal.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
            color="white"
            text
            v-bind="attrs"
            @click="snackbarLocal.show = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>

  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ValidationMixin from '@/Mixins/ValidationMixin'
import { EventBus } from '@/services/EventBus/EventBus'
import ContatoApi from '@/services/MinhaUnimed/DadosCadastrais/Contato/Contato.js'
import UsuarioService from '@/services/Usuario.js'
import DadosCadastraisService from '@/services/MinhaUnimed/DadosCadastrais/ViewDadosCadastrais/DadosCadastrais.js'
import ContatoModal from './ContatoModal.vue';
import ButtonRounded from '@/components/Shared/ButtonRounded/ButtonRounded.vue';

export default {
  mixins: [ValidationMixin],
  components: {
    ValidationProvider,
    ValidationObserver,
    ContatoModal,
    ButtonRounded,
  },

  data() {
    return {
      loadingAll: true,
      editar: JSON.parse(localStorage.getItem('optionEdit')),
      contatosFormatado: {
        cabecalho: {
          id: null,
          titulo: 'Canais oficiais de atendimento ao Beneficiário',
          subtitulo: 'Conforme disposto na RN Nº623/24 e decreto SAC nº 11.034/22',
          webSite: '',
          observacao: 'Para consultar a disponibilidade de atendimento presencial (se houver) as informações estarão disponíveis na aba "Endereço", identificados como: "SAC Atendimento Presencial" e/ou "Ouvidoria Atendimento Presencial"'
        },
        contatos: {
          PRIMEIRA_INSTANCIA: {
            id: null,
            telefone: '',
            whatsapp: '',
            email: '',
            observacao: ''
          },
          SEGUNDA_INSTANCIA: {
            id: null,
            telefone: '',
            whatsapp: '',
            email: '',
            observacao: ''
          }
        }
      },
      areaDisplayNames: {
        'PRIMEIRA_INSTANCIA': 'ATENDIMENTO AO CLIENTE/SAC',
        'SEGUNDA_INSTANCIA': 'OUVIDORIA'
      },
      areaDisplayNamesFormatado: {
        'PRIMEIRA_INSTANCIA': 'ATENDIMENTO AO CLIENTE/SAC<br>PRIMEIRA INSTÂNCIA',
        'SEGUNDA_INSTANCIA': 'OUVIDORIA<br>SEGUNDA INSTÂNCIA',
      },
      isTelefoneEditing: {},
      isWhatsappEditing: {},
      isEmailEditing: {},
      isObservacoesEditing: false,
      isTituloEditing: false,
      isSubtituloEditing: false,
      isWebsiteEditing: false,
      whatsappKey: 0,

      originalValues: {
        cabecalho: {
          titulo: '',
          subtitulo: '',
          webSite: '',
          observacao: ''
        },
        contatos: {
          PRIMEIRA_INSTANCIA: {
            telefone: '',
            whatsapp: '',
            email: '',
            observacao: ''
          },
          SEGUNDA_INSTANCIA: {
            telefone: '',
            whatsapp: '',
            email: '',
            observacao: ''
          }
        }
      },

      showContatoModal: false,
      currentObsModal: '',
      isContatoModalEditing: false,
      contatoModalTitle: '',
      currentObsAreaKey: null,

      contatoApiService: null,
      usuarioApiService: null,
      dadosCadastraisApiService: null,
      tokenBearer: '',
      unimedId: '',
      userPapel: '',
      currentDadosCadastrais: null,
      defaultDadosCadastraisDTO: {
        cdUnimed: null,
        id: null,
        ativa: true,
        dataInativacao: '',
        motivoInativacao: '',
        nomeFantasia: '',
        razaoSocial: '',
        dataFundacao: '',
        cnpj: '',
        inscricaoEstadual: '',
        inscricaoMunicipal: '',
        website: '',
        observacao: null,
        observacaoContato: null,
        porte: { id: null, nome: '', ativo: true, ordem: null, tipoDominio: null },
        participacoesSocietarias: []
      },

      isInitialLoading: false,
      isSavingInProgress: false,

      snackbarLocal: {
        show: false,
        text: '',
        color: '',
        timeout: 6000,
      },
      apiErrors: {
        cabecalho: {},
        PRIMEIRA_INSTANCIA: {},
        SEGUNDA_INSTANCIA: {}
      }
    }
  },

  computed: {
    editarSituacaoUnimed() {
      return !this.editar
    },
    podeEditarTituloSubtitulo() {
      return this.editar && this.userPapel === 'Administrador Brasil';
    },
    podeEditarObservacoes() {
      return this.editar && this.userPapel === 'Administrador Brasil';
    },
    podeEditarWebsite() {
      return this.editar && (this.userPapel === 'Administrador Brasil' || this.userPapel === 'Administrador Unimed' || this.userPapel === 'Dirigente');
    },
    formattedWebsite() {
      if (!this.contatosFormatado.cabecalho.webSite) return '#';
      let url = this.contatosFormatado.cabecalho.webSite;
      if (!/^https?:\/\//i.test(url)) {
        url = 'http://' + url;
      }
      return url;
    }
  },

  beforeUnmount() {
    this.loadingAll = false;
    this.isInitialLoading = false;
    this.isSavingInProgress = false;
  },

  async created() {
    this.tokenBearer = localStorage.getItem('tokenBearer');
    const baseUrl = this.$appConfig?.config?.API;
    this.unimedId = this.$idUnimed;

    try {
      if (!this.tokenBearer) {
        throw new Error('Token de autenticação não encontrado.');
      }
      if (!baseUrl) {
        throw new Error('URL Base da API (this.$appConfig.config.API) não configurada.');
      }
      if (!this.unimedId) {
        throw new Error('unimedId não configurado.');
      }
      this.contatoApiService = new ContatoApi(this.tokenBearer, baseUrl, this.unimedId);
      this.usuarioApiService = new UsuarioService(this.tokenBearer, baseUrl);
      this.dadosCadastraisApiService = new DadosCadastraisService(this.tokenBearer, baseUrl, this.unimedId);
    } catch (error) {
      console.error('ERRO DE INICIALIZAÇÃO: Falha ao instanciar serviços de API:', error);
      this.$root.$emit('snackbar', {
        text: `Erro de inicialização: ${error.message}`,
        color: 'error',
      });
      this.snackbarLocal.text = `Erro de inicialização: ${error.message}`;
      this.snackbarLocal.color = 'error';
      this.snackbarLocal.show = true;
    }
  },

  async beforeMount() {
    if (this.isInitialLoading || !this.contatoApiService || !this.usuarioApiService || !this.dadosCadastraisApiService) {
      console.log('beforeMount: Carregamento inicial já em andamento ou serviços não inicializados, ignorando nova requisição.');
      if (!this.contatoApiService || !this.usuarioApiService || !this.dadosCadastraisApiService) {
        this.loadingAll = false;
      }
      return;
    }

    this.loadingAll = true;
    this.isInitialLoading = true;

    try {
      await this.consultarContatos();
      await this.obterPapelUsuario();
      await this.fetchUnimedWebsite();
      console.log('beforeMount: Dados carregados com sucesso.');
    } catch (error) {
      console.error('beforeMount: Erro durante carregamento ou obtenção de papel:', error);

      const messageToDisplay = typeof error === 'string' ? error : error.message || 'Erro desconhecido ao carregar dados.';
      this.$root.$emit('snackbar', {
        text: `Erro fatal ao carregar: ${messageToDisplay}`,
        color: 'error',
      });
      this.snackbarLocal.text = `Erro fatal ao carregar: ${messageToDisplay}`;
      this.snackbarLocal.color = 'error';
      this.snackbarLocal.show = true;
    } finally {
      this.loadingAll = false;
      this.isInitialLoading = false;
      this.$emit('complete');
    }
  },

  async beforeCreate() {
    EventBus.$on('carregarContatosUnimed', () => {
      if (!this.isInitialLoading && !this.isSavingInProgress && this.contatoApiService) {
        console.log('EventBus: carregarContatosUnimed acionado, iniciando nova consulta.');
        this.consultarContatos();
      } else {
        console.log('EventBus: carregarContatosUnimed acionado, mas carregamento ou salvamento já em andamento, ou serviços não inicializados.');
      }
    })

    EventBus.$on('closeLoading', () => {
      this.loadingAll = false
    })
  },

  methods: {
    cleanNumber(value) {
      return value ? value.replace(/\D/g, '') : '';
    },

    formatPhoneNumber(value) {
      const cleaned = this.cleanNumber(value);
      const len = cleaned.length;

      if (cleaned.startsWith('0')) {
        if (len >= 4) {
          let formatted = cleaned.substring(0, 4);
          if (len > 4) {
            formatted += ` ${cleaned.substring(4, 7)}`;
          }
          if (len > 7) {
            formatted += ` ${cleaned.substring(7, 11)}`;
          }
          return formatted;
        }
      }
      else if (len === 10) {
        return `(${cleaned.substring(0, 2)}) ${cleaned.substring(2, 6)}-${cleaned.substring(6, 10)}`;
      } else if (len === 11) {
        return `(${cleaned.substring(0, 2)}) ${cleaned.substring(2, 7)}-${cleaned.substring(7, 11)}`;
      }
      return cleaned;
    },

    formatWhatsappNumber(value) {
      const cleaned = this.cleanNumber(value);
      const len = cleaned.length;

      if (cleaned.startsWith('0')) {
        if (len >= 4) {
          let formatted = cleaned.substring(0, 4);
          if (len > 4) {
            formatted += ` ${cleaned.substring(4, 7)}`;
          }
          if (len > 7) {
            formatted += ` ${cleaned.substring(7, 11)}`;
          }
          return formatted;
        }
      } else if (len === 10) {
        return `(${cleaned.substring(0, 2)}) ${cleaned.substring(2, 6)}-${cleaned.substring(6, 10)}`;
      } else if (len === 11) {
        return `(${cleaned.substring(0, 2)}) ${cleaned.substring(2, 7)}-${cleaned.substring(7, 11)}`;
      }
      return cleaned;
    },

    updatePhoneNumber(areaKey, event) {
      let value = event.target ? event.target.value : event;
      value = this.cleanNumber(value);
      this.contatosFormatado.contatos[areaKey].telefone = value.substring(0, 11);
    },

    updateWhatsappNumber(areaKey, event) {
      let value = event.target ? event.target.value : event;
      let cleaned = this.cleanNumber(value);
      this.contatosFormatado.contatos[areaKey].whatsapp = cleaned.substring(0, 11);
    },

    updateEmailToLowerCase(areaKey, event) {
      let value = event.target ? event.target.value : event;
      this.$set(this.contatosFormatado.contatos[areaKey], 'email', value.toLowerCase());
    },

    clearApiErrors() {
      this.$set(this.apiErrors, 'cabecalho', {});
      this.$set(this.apiErrors, 'PRIMEIRA_INSTANCIA', {});
      this.$set(this.apiErrors, 'SEGUNDA_INSTANCIA', {});
    },

    mapApiErrorsToFields(errorMessage) {
      this.clearApiErrors();

      if (typeof errorMessage === 'string') {
        if (errorMessage.includes('WhatsApp inválido para PRIMEIRA_INSTANCIA')) {
          this.$set(this.apiErrors.PRIMEIRA_INSTANCIA, 'whatsapp', errorMessage);
        } else if (errorMessage.includes('Telefone inválido para PRIMEIRA_INSTANCIA')) {
          this.$set(this.apiErrors.PRIMEIRA_INSTANCIA, 'telefone', errorMessage);
        } else if (errorMessage.includes('WhatsApp inválido para SEGUNDA_INSTANCIA')) {
          this.$set(this.apiErrors.SEGUNDA_INSTANCIA, 'whatsapp', errorMessage);
        } else if (errorMessage.includes('Telefone inválido para SEGUNDA_INSTANCIA')) {
          this.$set(this.apiErrors.SECONDA_INSTANCIA, 'telefone', errorMessage);
        } else if (errorMessage.includes('Observação inválida')) {
          this.$set(this.apiErrors.cabecalho, 'observacao', errorMessage);
        } else if (errorMessage.includes('Website inválido')) {
          this.$set(this.apiErrors.cabecalho, 'webSite', errorMessage);
        }
      }
    },

    validateForm() {
      if (this.$refs.observer) {
        const isValid = this.$refs.observer.validate();
        if (!isValid) {
          this.$root.$emit('snackbar', {
            text: 'Por favor, corrija os erros no formulário de Contatos.',
            color: 'error',
          });
          this.snackbarLocal.text = 'Por favor, corrija os erros no formulário de Contatos.';
          this.snackbarLocal.color = 'error';
          this.snackbarLocal.show = true;
        }
        return isValid;
      }
      console.warn('ValidationObserver ref "observer" não encontrado em Contato.vue. A validação não foi executada.');
      return true;
    },

    openContatoModal(observationText, isEditing, areaKey) {
      this.currentObsModal = observationText;
      this.isContatoModalEditing = isEditing;
      this.contatoModalTitle = isEditing ? `EDITAR OBSERVAÇÃO DE ${this.areaDisplayNames[areaKey]}` : `VISUALIZAR OBSERVAÇÃO DE ${this.areaDisplayNames[areaKey]}`;
      this.currentObsAreaKey = areaKey;
      this.showContatoModal = true;
    },

    closeContatoModal() {
      this.showContatoModal = false;
      this.currentObsModal = '';
      this.isContatoModalEditing = false;
      this.contatoModalTitle = '';
      this.currentObsAreaKey = null;
    },

    async saveObsFromContatoModal(updatedObservation) {
      if (this.currentObsAreaKey) {
        this.$set(this.originalValues.contatos[this.currentObsAreaKey], 'observacao', this.contatosFormatado.contatos[this.currentObsAreaKey].observacao);
        this.contatosFormatado.contatos[this.currentObsAreaKey].observacao = updatedObservation;
        await this.saveAllChanges(`Observação de ${this.areaDisplayNames[this.currentObsAreaKey]}`, this.currentObsAreaKey, 'observacao');
      }
      this.closeContatoModal();
    },

    async obterPapelUsuario() {
      if (!this.usuarioApiService) {
        console.error('ERRO: Serviço UsuarioService não inicializado. Não é possível obter o papel do usuário.');
        this.$root.$emit('snackbar', {
          text: 'Erro ao obter papel do usuário: Serviço de API não inicializado.',
          color: 'error',
        });
        this.snackbarLocal.text = `Erro ao obter papel do usuário: Serviço de API não inicializado.`;
        this.snackbarLocal.color = 'error';
        this.snackbarLocal.show = true;
        throw new Error('Serviço UsuarioService não inicializado.');
      }
      try {
        const response = await this.usuarioApiService.getUser();
        this.userPapel = response.data.papel || 'Desconhecido';
      } catch (error) {
        console.error('ERRO: Erro ao obter dados do usuário da API:', error);
        this.userPapel = 'Erro';
        const messageToDisplay = typeof error === 'string' ? error : error.message || 'Erro desconhecido ao obter papel do usuário.';
        this.$root.$emit('snackbar', {
          text: `Erro ao obter papel do usuário: ${messageToDisplay}`,
          color: 'error',
        });
        this.snackbarLocal.text = `Erro ao obter papel do usuário: ${messageToDisplay}`;
        this.snackbarLocal.color = 'error';
        this.snackbarLocal.show = true;
        throw error;
      }
    },

    async consultarContatos() {
      if (!this.contatoApiService) {
        console.error('ERRO DE CONSULTA: Serviço ContatoApi não inicializado (contatoApiService é nulo). Verifique logs de inicialização.');
        this.$root.$emit('snackbar', {
          text: 'Erro de consulta: Serviço de Contato API não inicializado.',
          color: 'error',
        });
        this.snackbarLocal.text = 'Erro de consulta: Serviço de Contato API não inicializado.';
        this.snackbarLocal.color = 'error';
        this.snackbarLocal.show = true;
        throw new Error("Serviço ContatoApi não inicializado.");
      }

      this.contatosFormatado = {
        cabecalho: {
          id: null,
          titulo: 'Canais oficiais de atendimento ao Beneficiário',
          subtitulo: 'Conforme disposto na RN Nº623/24 e decreto SAC nº 11.034/22',
          webSite: '',
          observacao: 'Para consultar a disponibilidade de atendimento presencial (se houver) as informações estarão disponíveis na aba "Endereço", identificados como: "SAC Atendimento Presencial" e/ou "Ouvidoria Atendimento Presencial"'
        },
        contatos: {
          PRIMEIRA_INSTANCIA: {
            id: null,
            telefone: '',
            whatsapp: '',
            email: '',
            observacao: ''
          },
          SEGUNDA_INSTANCIA: {
            id: null,
            telefone: '',
            whatsapp: '',
            email: '',
            observacao: ''
          }
        }
      };
      this.clearApiErrors();

      try {
        const response = await this.contatoApiService.getContatos();
        const apiData = response.data;

        this.contatosFormatado.cabecalho.id = apiData.cabecalho?.id || null;
        this.contatosFormatado.cabecalho.titulo = apiData.cabecalho?.titulo || this.contatosFormatado.cabecalho.titulo;
        this.contatosFormatado.cabecalho.subtitulo = apiData.cabecalho?.subtitulo || this.contatosFormatado.cabecalho.subtitulo;
        this.contatosFormatado.cabecalho.observacao = apiData.cabecalho?.observacao || this.contatosFormatado.cabecalho.observacao;


        this.contatosFormatado.contatos.PRIMEIRA_INSTANCIA = {
          id: apiData.contatos?.PRIMEIRA_INSTANCIA?.id || null,
          telefone: apiData.contatos?.PRIMEIRA_INSTANCIA?.telefone || '',
          whatsapp: apiData.contatos?.PRIMEIRA_INSTANCIA?.whatsapp || '',
          email: apiData.contatos?.PRIMEIRA_INSTANCIA?.email || '',
          observacao: apiData.contatos?.PRIMEIRA_INSTANCIA?.observacao || ''
        };
        this.contatosFormatado.contatos.SEGUNDA_INSTANCIA = {
          id: apiData.contatos?.SEGUNDA_INSTANCIA?.id || null,
          telefone: apiData.contatos?.SEGUNDA_INSTANCIA?.telefone || '',
          whatsapp: apiData.contatos?.SEGUNDA_INSTANCIA?.whatsapp || '',
          email: apiData.contatos?.SEGUNDA_INSTANCIA?.email || '',
          observacao: apiData.contatos?.SEGUNDA_INSTANCIA?.observacao || ''
        };

      } catch (err) {
        console.error('ERRO NO GET de contatos da API (tratado silenciosamente):', err);
      } finally {
        for (const areaKey in this.contatosFormatado.contatos) {
          this.$set(this.isTelefoneEditing, areaKey, false);
          this.$set(this.isWhatsappEditing, areaKey, false);
          this.$set(this.isEmailEditing, areaKey, false);
        }
        this.isObservacoesEditing = false;
        this.isTituloEditing = false;
        this.isSubtituloEditing = false;
        this.isWebsiteEditing = false;
      }
    },

    async fetchUnimedWebsite() {
      if (!this.dadosCadastraisApiService) {
        console.error('ERRO DE CONSULTA: Serviço DadosCadastraisService não inicializado. Não é possível obter o website da Unimed.');
        this.$root.$emit('snackbar', {
          text: 'Erro ao obter o website: Serviço de Dados Cadastrais API não inicializado.',
          color: 'error',
        });
        this.snackbarLocal.text = `Erro ao obter o website: Serviço de Dados Cadastrais API não inicializado.`;
        this.snackbarLocal.color = 'error';
        this.snackbarLocal.show = true;
        this.contatosFormatado.cabecalho.webSite = '';
        this.currentDadosCadastrais = { ...this.defaultDadosCadastraisDTO };
        return;
      }
      try {
        const response = await this.dadosCadastraisApiService.getDadosCadastrais();
        this.currentDadosCadastrais = {
          ...this.defaultDadosCadastraisDTO,
          ...response.data,
          porte: response.data?.porte ? { ...this.defaultDadosCadastraisDTO.porte, ...response.data.porte } : this.defaultDadosCadastraisDTO.porte,
          participacoesSocietarias: response.data?.participacoesSocietarias || []
        };
        this.contatosFormatado.cabecalho.webSite = this.currentDadosCadastrais.website || '';
      } catch (error) {
        console.error('Erro ao buscar o website da Unimed:', error);
        this.contatosFormatado.cabecalho.webSite = '';
        this.currentDadosCadastrais = { ...this.defaultDadosCadastraisDTO };
        const messageToDisplay = typeof error === 'string' ? error : error.message || 'Erro desconhecido ao carregar o website.';
        this.$root.$emit('snackbar', {
          text: `Erro ao carregar o website: ${messageToDisplay}`,
          color: 'error',
        });
        this.snackbarLocal.text = `Erro ao carregar o website: ${messageToDisplay}`;
        this.snackbarLocal.color = 'error';
        this.snackbarLocal.show = true;
      }
    },

    async saveAllChanges(fieldDisplayName = "campo", areaKey = null, propName) {
      if (!this.contatoApiService && propName !== 'webSite') {
        console.error('ERRO DE SALVAMENTO: Serviço ContatoApi não disponível. Verifique a inicialização.');
        this.$root.$emit('snackbar', {
          text: 'Erro ao salvar: Serviço de Contato API não inicializado.',
          color: 'error',
        });
        this.snackbarLocal.text = `Erro ao salvar: Serviço de Contato API não inicializado.`;
        this.snackbarLocal.color = 'error';
        this.snackbarLocal.show = true;
        return;
      }
      if (!this.dadosCadastraisApiService && propName === 'webSite') {
        console.error('ERRO DE SALVAMENTO: Serviço DadosCadastraisService não disponível. Verifique a inicialização.');
        this.$root.$emit('snackbar', {
          text: 'Erro ao salvar: Serviço de Dados Cadastrais API não inicializado.',
          color: 'error',
        });
        this.snackbarLocal.text = `Erro ao salvar: Serviço de Dados Cadastrais API não inicializado.`;
        this.snackbarLocal.color = 'error';
        this.snackbarLocal.show = true;
        return;
      }

      if (this.isSavingInProgress) {
        console.warn('Salvamento já em andamento, ignorando nova requisição.');
        return;
      }

      this.loadingAll = true;
      this.isSavingInProgress = true;
      this.clearApiErrors();

      try {
        if (propName === 'webSite') {
          if (!this.currentDadosCadastrais) {
            await this.fetchUnimedWebsite();
            if (!this.currentDadosCadastrais) {
              throw new Error('Não foi possível obter os dados cadastrais atuais para atualização do website.');
            }
          }

          const dadosCadastraisPayload = { ...this.currentDadosCadastrais };
          dadosCadastraisPayload.website = this.contatosFormatado.cabecalho.webSite;

          if (dadosCadastraisPayload.participacoesSocietarias && Array.isArray(dadosCadastraisPayload.participacoesSocietarias)) {
            dadosCadastraisPayload.participacoesSocietarias = dadosCadastraisPayload.participacoesSocietarias.map(item => ({ id: item.id }));
          }

          console.log('Payload para putDadosCadastrais:', JSON.stringify(dadosCadastraisPayload, null, 2));

          await this.dadosCadastraisApiService.putDadosCadastrais(dadosCadastraisPayload);

          this.$root.$emit('snackbar', {
            text: `${fieldDisplayName} atualizado com sucesso!`,
            color: 'success',
          });
          this.snackbarLocal.text = `${fieldDisplayName} atualizado com sucesso!`;
          this.snackbarLocal.color = 'success';
          this.snackbarLocal.show = true;

        } else {
          const dataToSave = {
            cabecalho: {
              id: this.contatosFormatado.cabecalho.id,
              titulo: this.contatosFormatado.cabecalho.titulo,
              subtitulo: this.contatosFormatado.cabecalho.subtitulo,
              observacao: this.contatosFormatado.cabecalho.observacao,
            },
            contatos: {
              PRIMEIRA_INSTANCIA: { ...this.contatosFormatado.contatos.PRIMEIRA_INSTANCIA },
              SEGUNDA_INSTANCIA: { ...this.contatosFormatado.contatos.SEGUNDA_INSTANCIA },
            }
          };
          await this.contatoApiService.postContatos(dataToSave);
          this.$root.$emit('snackbar', {
            text: `${fieldDisplayName} atualizado com sucesso!`,
            color: 'success',
          });
          this.snackbarLocal.text = `${fieldDisplayName} atualizado com sucesso!`;
          this.snackbarLocal.color = 'success';
          this.snackbarLocal.show = true;
        }

      } catch (error) {
        console.error('ERRO DE SALVAMENTO GERAL: Falha ao salvar dados na API:', error);

        if (areaKey && propName) {
          if (this.originalValues.contatos[areaKey] && this.originalValues.contatos[areaKey][propName] !== undefined) {
            this.$set(this.contatosFormatado.contatos[areaKey], propName, this.originalValues.contatos[areaKey][propName]);
            console.log(`[DEBUG REVERSAO] Campo ${fieldDisplayName} revertido para valor original:`, this.originalValues.contatos[areaKey][propName]);
          }
        } else if (propName && this.originalValues.cabecalho && this.originalValues.cabecalho[propName] !== undefined) {
          this.$set(this.contatosFormatado.cabecalho, propName, this.originalValues.cabecalho[propName]);
          console.log(`[DEBUG REVERSAO] Campo ${fieldDisplayName} revertido para valor original:`, this.originalValues.cabecalho[propName]);
        }

        const isNotFoundError = error.response && error.response.status === 404;
        const messageFromApi = error.response && error.response.data && error.response.data.message;
        const isExpectedNotFoundError = isNotFoundError && messageFromApi && messageFromApi.includes('Contato não encontrado');

        if (!isExpectedNotFoundError) {
          const messageToDisplay = typeof error === 'string' ? error : error.message || `Erro desconhecido ao salvar ${fieldDisplayName}.`;
          this.$root.$emit('snackbar', {
            text: `Erro ao salvar ${fieldDisplayName}: ${messageToDisplay}`,
            color: 'error',
          });
          this.snackbarLocal.text = `Erro ao salvar ${fieldDisplayName}: ${messageToDisplay}`;
          this.snackbarLocal.color = 'error';
          this.snackbarLocal.show = true;
          this.mapApiErrorsToFields(messageToDisplay);
        } else {
          console.log(`Erro 404 "Contato não encontrado" ao salvar ${fieldDisplayName}. Nenhuma mensagem de alerta exibida.`);
        }

      } finally {
        this.loadingAll = false;
        this.isSavingInProgress = false;
        this.resetAllEditingStates();
      }
    },

    saveContactField(field, areaKey) {
      this.exitEditMode(field, areaKey);
    },
    saveHeaderField(field) {
      if (field === 'titulo') this.isTituloEditing = false;
      if (field === 'subtitulo') this.isSubtituloEditing = false;
      if (field === 'observacao') this.isObservacoesEditing = false;
      if (field === 'webSite') this.isWebsiteEditing = false;
    },
    saveContatosToApi() { console.warn('saveContatosToApi não deve ser chamado diretamente. Use saveAllChanges.'); },


    exitEditMode(field, areaKey) {
      if (field === 'telefone') {
        this.$set(this.isTelefoneEditing, areaKey, false);
      } else if (field === 'whatsapp') {
        this.$set(this.isWhatsappEditing, areaKey, false);
      } else if (field === 'email') {
        this.$set(this.isEmailEditing, areaKey, false);
      }
    },

    async enableEdit(field, areaKey) {
      if (!this.editar) {
        return;
      }
      this.resetAllEditingStates();
      if (this.apiErrors[areaKey]) {
        this.$delete(this.apiErrors[areaKey], field);
      }

      if (this.contatosFormatado.contatos[areaKey] && this.originalValues.contatos[areaKey]) {
        this.$set(this.originalValues.contatos[areaKey], field, this.contatosFormatado.contatos[areaKey][field]);
        console.log(`[DEBUG REVERSAO] Valor original de ${field} ${areaKey} salvo:`, this.originalValues.contatos[areaKey][field]);
      }

      if (field === 'telefone') {
        this.$set(this.isTelefoneEditing, areaKey, true);
      } else if (field === 'whatsapp') {
        this.$set(this.isWhatsappEditing, areaKey, true);
      } else if (field === 'email') {
        this.$set(this.isEmailEditing, areaKey, true);
      }

      const refName = `input-${areaKey}-${field}`;

      let targetInputComponent = null;
      let attempts = 0;
      const maxAttempts = 20;
      const intervalTime = 20;

      while (!targetInputComponent && attempts < maxAttempts) {
        await new Promise(resolve => setTimeout(resolve, intervalTime));
        targetInputComponent = this.$refs[refName];

        if (Array.isArray(targetInputComponent)) {
          targetInputComponent = targetInputComponent[0];
        }

        if (!targetInputComponent) {
          console.log(`[DEBUG FOCO] Ref para ${refName} ainda não disponível. Tentando novamente... (${attempts + 1}/${maxAttempts})`);
        }
        attempts++;
      }

      if (targetInputComponent) {
        if (typeof targetInputComponent.focus === 'function') {
          targetInputComponent.focus();
        }

        setTimeout(() => {
          let nativeInputElement = null;
          if (targetInputComponent.$el) {
            nativeInputElement = targetInputComponent.$el.querySelector('input');
            if (!nativeInputElement) {
              nativeInputElement = targetInputComponent.$el.querySelector('textarea');
            }
          }

          if (nativeInputElement) {
            nativeInputElement.focus();
            nativeInputElement.select();
            console.log(`[DEBUG FOCO] Foco e seleção aplicados em ${field} - ${areaKey}.`);
          } else {
            console.warn(`[DEBUG FOCO] Input nativo NÃO ENCONTRADO dentro do componente Vuetify para ${field} - ${areaKey}.`);
            console.log('Elemento raiz do componente Vuetify:', targetInputComponent.$el);
          }
        }, 50);
      } else {
        console.warn(`[DEBUG FOCO] Falha total: Componente input Vuetify para ${field} - ${areaKey} não encontrado após ${maxAttempts} tentativas.`);
        console.log('Conteúdo final de this.$refs para este campo:', this.$refs[refName]);
      }
    },

    async enableEditTitulo() {
      if (!this.editar || !this.podeEditarTituloSubtitulo) {
        return;
      }
      this.resetAllEditingStates();

      this.originalValues.cabecalho.titulo = this.contatosFormatado.cabecalho.titulo;
      console.log(`[DEBUG REVERSAO] Valor original de Titulo salvo:`, this.originalValues.cabecalho.titulo);

      this.isTituloEditing = true;
      this.$delete(this.apiErrors.cabecalho, 'titulo');

      let attempts = 0;
      const maxAttempts = 10;
      const intervalTime = 20;
      let targetInputComponent = null;

      while (!targetInputComponent && attempts < maxAttempts) {
        await new Promise(resolve => setTimeout(resolve, intervalTime));
        targetInputComponent = this.$refs.tituloInput;
        if (!targetInputComponent) {
          console.log(`[DEBUG FOCO TITULO] Ref para tituloInput ainda não disponível. Tentando novamente... (${attempts + 1}/${maxAttempts})`);
        }
        attempts++;
      }

      if (targetInputComponent) {
        if (typeof targetInputComponent.focus === 'function') {
          targetInputComponent.focus();
        }
        setTimeout(() => {
          const nativeInput = targetInputComponent.$el.querySelector('input');
          if (nativeInput) {
            nativeInput.focus();
            nativeInput.select();
          }
        }, 50);
      } else {
        console.warn(`[DEBUG FOCO TITULO] Falha total: Componente input Vuetify para Título não encontrado após ${maxAttempts} tentativas.`);
      }
    },

    async enableEditSubtitulo() {
      if (!this.editar || !this.podeEditarTituloSubtitulo) {
        return;
      }
      this.resetAllEditingStates();

      this.originalValues.cabecalho.subtitulo = this.contatosFormatado.cabecalho.subtitulo;
      console.log(`[DEBUG REVERSAO] Valor original de Subtitulo salvo:`, this.originalValues.cabecalho.subtitulo);

      this.isSubtituloEditing = true;
      this.$delete(this.apiErrors.cabecalho, 'subtitulo');

      let attempts = 0;
      const maxAttempts = 10;
      const intervalTime = 20;
      let targetInputComponent = null;

      while (!targetInputComponent && attempts < maxAttempts) {
        await new Promise(resolve => setTimeout(resolve, intervalTime));
        targetInputComponent = this.$refs.subtituloInput;
        if (!targetInputComponent) {
          console.log(`[DEBUG FOCO SUBTITULO] Ref para subtituloInput ainda não disponível. Tentando novamente... (${attempts + 1}/${maxAttempts})`);
        }
        attempts++;
      }

      if (targetInputComponent) {
        if (typeof targetInputComponent.focus === 'function') {
          targetInputComponent.focus();
        }
        setTimeout(() => {
          const nativeInput = targetInputComponent.$el.querySelector('input');
          if (nativeInput) {
            nativeInput.focus();
            nativeInput.select();
          }
        }, 50);
      } else {
        console.warn(`[DEBUG FOCO SUBTITULO] Falha total: Componente input Vuetify para Subtítulo não encontrado após ${maxAttempts} tentativas.`);
      }
    },

    async enableEditWebsite() {
      if (!this.editar || !this.podeEditarWebsite) {
        return;
      }
      this.resetAllEditingStates();

      this.originalValues.cabecalho.webSite = this.contatosFormatado.cabecalho.webSite;
      console.log(`[DEBUG REVERSAO] Valor original de Website salvo:`, this.originalValues.cabecalho.webSite);

      this.isWebsiteEditing = true;
      this.$delete(this.apiErrors.cabecalho, 'webSite');

      let targetInputComponent = null;
      let attempts = 0;
      const maxAttempts = 10;
      const intervalTime = 20;

      while (!targetInputComponent && attempts < maxAttempts) {
        await new Promise(resolve => setTimeout(resolve, intervalTime));
        targetInputComponent = this.$refs.websiteInput;
        if (!targetInputComponent) {
          console.log(`[DEBUG FOCO WEBSITE] Ref para websiteInput ainda não disponível. Tentando novamente... (${attempts + 1}/${maxAttempts})`);
        }
        attempts++;
      }

      if (targetInputComponent) {
        if (typeof targetInputComponent.focus === 'function') {
          targetInputComponent.focus();
        }
        setTimeout(() => {
          const nativeInput = targetInputComponent.$el.querySelector('input');
          if (nativeInput) {
            nativeInput.focus();
            nativeInput.select();
          }
        }, 50);
      } else {
        console.warn(`[DEBUG FOCO WEBSITE] Falha total: Componente input Vuetify para Website não encontrado após ${maxAttempts} tentativas.`);
      }
    },

    async enableEditObservacoes() {
      if (!this.editar || !this.podeEditarObservacoes) {
        return;
      }
      this.resetAllEditingStates();

      this.originalValues.cabecalho.observacao = this.contatosFormatado.cabecalho.observacao;
      console.log(`[DEBUG REVERSAO] Valor original de Observacoes salvo:`, this.originalValues.cabecalho.observacao);

      this.isObservacoesEditing = true;
      this.$delete(this.apiErrors.cabecalho, 'observacao');

      let attempts = 0;
      const maxAttempts = 10;
      const intervalTime = 20;
      let targetInputComponent = null;

      while (!targetInputComponent && attempts < maxAttempts) {
        await new Promise(resolve => setTimeout(resolve, intervalTime));
        targetInputComponent = this.$refs.observacoesInput;
        if (!targetInputComponent) {
          console.log(`[DEBUG FOCO OBSERVACOES] Ref para observacoesInput ainda não disponível. Tentando novamente... (${attempts + 1}/${maxAttempts})`);
        }
        attempts++;
      }

      if (targetInputComponent) {
        if (typeof targetInputComponent.focus === 'function') {
          targetInputComponent.focus();
        }
        setTimeout(() => {
          const nativeTextarea = targetInputComponent.$el.querySelector('textarea');
          if (nativeTextarea) {
            nativeTextarea.focus();
            nativeTextarea.select();
          }
        }, 50);
      } else {
        console.warn(`[DEBUG FOCO OBSERVACOES] Falha total: Componente input Vuetify para Observações não encontrado após ${maxAttempts} tentativas.`);
      }
    },

    resetAllEditingStates() {
      for (const areaKey in this.contatosFormatado.contatos) {
        this.$set(this.isTelefoneEditing, areaKey, false);
        this.$set(this.isWhatsappEditing, areaKey, false);
        this.$set(this.isEmailEditing, areaKey, false);
      }
      this.isObservacoesEditing = false;
      this.isTituloEditing = false;
      this.isSubtituloEditing = false;
      this.isWebsiteEditing = false;
    },

    getPhoneMaxlength(value) {
      const cleaned = this.cleanNumber(value);
      if (cleaned.length > 0 && cleaned.startsWith('0')) {
        return 13;
      }
      return 15;
    },

    getWhatsappMaxlength(value) {
      const cleaned = this.cleanNumber(value);
      if (cleaned.length > 0 && cleaned.startsWith('0')) {
        return 13;
      }
      return 15;
    }
  }
}
</script>

<style scoped>
.title-field-wrapper .v-text-field,
.subtitle-field-wrapper .v-text-field,
.website-input-fix.v-text-field,
.observations-textarea-fix.v-textarea {
  width: 100%;
  max-width: 100%;
}

.title-field-wrapper .v-text-field >>> .v-input__control,
.subtitle-field-wrapper .v-text-field >>> .v-input__control,
.website-input-fix.v-text-field >>> .v-input__control,
.observations-textarea-fix.v-textarea >>> .v-input__control {
  width: 100% !important;
}

.v-col {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.container {
  padding: 16px;
}

.editable-text-field {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0px 0px;
  border: 1px solid transparent;
  border-radius: 4px;
  min-height: 25px;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.87);
  width: 100%;
  margin-bottom: 0;
}

.editable-text-field:hover {
  background-color: rgba(0, 0, 0, 0.04);
  border-color: rgba(0, 0, 0, 0.38);
}

.editable-text-field:empty::before {
  content: "Clique para adicionar";
  color: rgba(0, 0, 0, 0.6);
}

.editable-text-field.disabled-click {
  cursor: default;
  pointer-events: none;
  border-color: transparent !important;
  background-color: transparent !important;
}

.title-text-field, .subtitle-text-field, .website-text-field {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.input-alignment-fix >>> .v-input__control {
  min-height: 25px !important;
  height: auto !important;
}

.input-alignment-fix >>> .v-input__slot {
  padding: 0px 0px !important;
  align-items: center !important;
  margin-bottom: 0 !important;
  background-color: transparent !important;
}

.input-alignment-fix >>> .v-input__control .v-input__slot input,
.input-alignment-fix >>> .v-input__control .v-input__slot textarea {
  padding: 0 !important;
}

.title-field-wrapper .v-text-field,
.subtitle-field-wrapper .v-text-field,
.website-input-fix.v-text-field,
.observations-textarea-fix.v-textarea {
  margin-top: 0 !important;
}


.observations-textarea-fix.v-textarea {
  margin-top: 0 !important;
}
.observations-textarea-fix.v-textarea >>> .v-input__control .v-input__slot {
  min-height: 100px;
  align-items: flex-start;
  background-color: transparent !important;
}
.observations-textarea-fix.v-textarea >>> .v-input__control .v-input__slot fieldset {
  border-color: rgba(0, 0, 0, 0.38) !important;
  border-width: 1px !important;
}
.observations-textarea-fix.v-textarea.v-input--is-focused >>> .v-input__control .v-input__slot fieldset {
  border-color: transparent !important;
}
.observations-textarea-fix.v-textarea >>> .v-input__control .v-input__slot textarea {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  line-height: 1.5;
}

.observations-display-field {
  margin-top: 2px !important;
  position: relative;
  top: 0 !important;
  padding: 0px 0px !important;
  align-items: flex-start;
  word-break: break-word;
  overflow: auto;
  text-overflow: unset;
  min-height: 100px;
  line-height: 1.5;
}

.v-simple-table th, .v-simple-table td {
  padding: 0 8px !important;
  vertical-align: middle;
  height: 40px;
  line-height: normal;
}
td.table-cell-padding-fix {
  padding: 4px 8px !important;
}
.observation-column-flexible.table-cell-padding-fix {

  padding-left: 8px !important;
  padding-right: 8px !important;
}
.observation-column-flexible.table-cell-padding-fix > .button-rounded {
  margin: 0 !important;
  flex-shrink: 0;
  line-height: 1;
}
.full-width-table {
  width: 100%;
  border-collapse: collapse;
}

.table-no-padding {
  margin-left: -16px;
  margin-right: -16px;
  width: calc(100% + 32px);
}


.area-column-flexible {
  white-space: normal;
  width: 25%;
  min-width: 230px;
}
.phone-column-flexible {
  width: 18%;
  min-width: 120px;
}
.whatsapp-column-flexible {
  width: 18%;
  min-width: 120px;
}
.email-column-flexible {
  width: 30%;
  min-width: 250px;
}
.observation-column-flexible {
  width: 9%;
  min-width: 50px;
}
.v-simple-table td:not(.table-cell-padding-fix) {
  padding: 8px !important;
}
.email-cell-stretch {
  width: auto !important;
  min-width: 300px !important;
}
.full-width-input {
  background-color: white;
}

.no-border-focus.v-text-field,
.no-border-focus.v-textarea {
  width: 100%;
}
.no-border-focus.v-text-field >>> .v-input__control,
.no-border-focus.v-textarea >>> .v-input__control {
  width: 100% !important;
}
.no-border-focus.v-text-field >>> .v-input__slot,
.no-border-focus.v-textarea >>> .v-input__control .v-input__slot {
  width: 100% !important;
  display: flex !important;
}
.no-border-focus.v-text-field >>> .v-input__control .v-input__slot fieldset,
.no-border-focus.v-textarea >>> .v-input__control .v-input__slot fieldset {
  border-color: transparent !important;
  border-width: 0px !important;
}
.no-border-focus.v-text-field >>> .v-input__control .v-input__slot::before,
.no-border-focus.v-text-field >>> .v-input__control .v-input__slot::after,
.no-border-focus.v-textarea >>> .v-input__control .v-input__slot::before,
.no-border-focus.v-textarea >>> .v-input__control .v-input__slot::after {
  display: none !important;
}

.full-width-input >>> .v-input__control .v-text-field__slot input,
.full-width-input >>> .v-input__control .v-textarea__slot textarea {
  width: 100% !important;
  max-width: none !important;
  min-width: 0 !important;
  flex-grow: 1 !important;
  outline: none !important;
  box-shadow: none !important;
}

.table-cell-display-fix {
  padding: 4px 12px !important;
  height: 100% !important;
  display: flex;
  align-items: center;
}

.table-cell-editor-fix {
  margin-top: 0 !important;
  background-color: transparent !important;
}

.table-cell-editor-fix >>> .v-input__control {
  min-height: 40px !important;
  height: auto !important;
}

.table-cell-editor-fix >>> .v-input__slot {
  padding: 0px 12px !important;
  align-items: center !important;
  margin-bottom: 0 !important;
}

.table-cell-editor-fix.v-text-field--outlined >>> fieldset {
  border-color: transparent !important;
  border-width: 0px !important;
}

.no-underline-link {
  text-decoration: none !important;
}

.website-label {
  display: block !important;
}

.website-display-block {
  display: block !important;
}

.title-display-margin {
  margin-bottom: 4px !important;
}

.subtitle-display-margin {
  margin-bottom: 0px !important;
}

.website-label-display-margin {
  margin-bottom: 4px !important;
  margin-top: 22px !important;
}

.website-link-display-margin {
  margin-top: 4px;
  margin-bottom: 16px !important;
}
</style>